// extracted by mini-css-extract-plugin
export default {"resendBtn":"UserTableOktaStatusCell_resendBtn__l34nZ"};